import { defineStore } from 'pinia'

export const useSessionStore = defineStore('session', {
  state: () => (
    {
      cc: undefined,
      orgResponse: undefined,
      permissions: undefined,
      isAuthenticated: false,
      userData: undefined,
      goContexts: undefined,
      homeBreadcrumb: undefined,
      targetUrl: null,
      openContexts: {},
      entitlements: undefined,
      debug: {
        printos_global: {
          isDebug: false,
          level: 0,
        }
      },
    }),
  getters: {
  },
  actions: {
    setClientConfig(cc) {
      this.cc = cc;
    },
    setOrgResponse(orgResponse) {
      this.orgResponse = orgResponse;
    },
    setPermissions(permissions) {
      this.permissions = permissions;
    },
    setIsAuthenticated(authenticated) {
      this.isAuthenticated = authenticated;
    },
    setUserData(userData) {
      this.userData = userData;
    },
    setGoContexts(goContexts) {
      this.goContexts = goContexts;
    },
    hasGoContexts() {
      return this.goContexts !== undefined;
    },
    setHomeBreadcrumb(value) {
      this.homeBreadcrumb = value;
    },
    setTargetUrl(url) {
      this.targetUrl = url;
    },
    addOpenContext(id, windowRef) {
      this.openContexts[id] = windowRef;
    },
    removeOpenContext(id) {
      delete this.openContexts[id];
    },
    getOpenContext(id) {
      return this.openContexts[id];
    },
    setEntitlements(entitlements) {
      this.entitlements = entitlements;
    },
    setDebug(isDebug, category = null, level = 0) {
      this.debug[category] = {
        level,
        isDebug,
      }
    }
  },
});
